<template lang="pug">
	div
		.row.padded.padded-top.overview
			.col-7.pr-4
					h2.font-weight-lighter The Evolution of
					h1.font-weight-bolder DIGITAL IDENTITY
					.d-flex.flex-row
							span.mr-4 SECURE
							span.mr-4 &#183;
							span.mr-4 IMMUTABLE
							span.mr-4 &#183;
							span.mr-4 IRREFUTABLE
					p.py-4 Xendity eKYC solution provides you an efficient, seamless, and convenient onboarding process with the latest technology in digital ID verification.
					router-link.btn.btn-white(v-if="!$store.getters.isLoggedIn" tag="button" to="/auth") Try it Free
					router-link.btn.btn-white(v-else tag="button" :to="$store.getters.redirectRoute") Try it Free
			.col-5
				img(width="100%" src="@/assets/images/image-top-banner.png" alt="overview")
		.row.padded.d-flex.flex-column.overview-2
			h2.top-left-bar Leader in E-KYC
			p.content Over 150 brands around the globe have been using Xendity's EKYC and achieved measurable fastest and secured result
			.d-flex.flex-row
				.highlight-item
					h1.title 2,123,121+
					.label ID Scan
				.highlight-item
					h1.title 1,311,573+
					.label Face Scan
				.highlight-item
					h1.title 6,197,126+
					.label Document Scan
				.highlight-item
					h1.title 12,233+
					.label AML/CFT Screening
		.row.padded.d-flex.flex-column.overview-3
			.d-flex.flex-row.justify-content-between.mb-4
				h2.top-left-bar.text-dark.font-weight-bolder Why Xendity
				.d-flex
					button.m-auto.carousel-btn(@click="clickLeft") &#8249;
					button.m-auto.carousel-btn(@click="clickRight") &#8250;
			.d-flex.flex-row.carousel
				.item(@click="scroll(0)")
					img(src="@/assets/images/icon-why-xendity-1.png" alt="carousel")
					h1.title.text-dark ID Scanner
					.label High precision real-time text recognition. Tap to view list of countries and IDs type supported.
				.item(@click="scroll(1)")
					img(src="@/assets/images/icon-why-xendity-2.png" alt="carousel")
					h1.title.text-dark Document Scanner
					.label Producing a high degree of recognition accuracy on Malaysia “Employees Provident Fund” document via mobile device camera.
				.item(@click="scroll(2)")
					img(src="@/assets/images/icon-why-xendity-3.png" alt="carousel")
					h1.title.text-dark Face Recognition
					.label Detect and compare the similarity of faces. Facial characteristic like smiling and eye blinking to determine the liveness of individual.
		.row.padded.overview-4.d-flex.flex-column
			h1.top-center-bar See How Business Like Yours are using <br> Xendity APIs Today.
			.d-flex.flex-row.flex-wrap
				.category-item
					img(src="@/assets/images/icon-banking.png" alt="icon")
					h4.label Banking
					p.content Bank account opening &<br> Online loan application.
				.category-item
					img(src="@/assets/images/icon-insurance.png" alt="icon")
					h4.label Insurance
					p.content Enable insurers to <br>replace a set of documents.
				.category-item
					img(src="@/assets/images/icon-ewallet.png" alt="icon")
					h4.label E-wallet
					p.content Protect your eWallet <br>from unauthorised transactions.
				.category-item
					img(src="@/assets/images/icon-proptech.png" alt="icon")
					h4.label Prop-Tech
					p.content Integrate with premises <br>access control solution.
				.category-item
					img(src="@/assets/images/icon-fintech.png" alt="icon")
					h4.label Fin-Tech
					p.content Preventing financial <br>crime that is done digitally.
				.category-item
					img(src="@/assets/images/icon-money-remittance.png" alt="icon")
					h4.label Money Remittance
					p.content Top-ups by online banking & <br>online shopping in foreign currencies.
		.row.padded.overview-5.d-flex.flex-column
			h1.top-center-bar Don't Just Take Our Word for It
			.d-flex.flex-row.my-4
				.col-4.brand-content.mx-auto
					img.mr-auto.mb-4(src="@/assets/images/quote.png" alt="quotes")
					p.mb-auto Lorem ipsum dolor sit amet, consectetur adipis cing elit, sed do eiusmod tempor incididunt ut et dolore magna aliqua. 
					.d-flex.flex-row
						img(src="@/assets/images/people-image-sample.png" alt="profile")
						.d-flex.flex-column
							strong.mt-auto.ml-2 {{name}}
							span.mb-auto.ml-2 {{title}}
				.col-7.d-flex.flex-row.flex-wrap.brand-container
					.brand-item.ctos(@mouseover="update('CTOS')")
					.brand-item.artajasa(@mouseover="update('Artajasa')")
					.brand-item.finexus(@mouseover="update('Finexus')")
					.brand-item.greenpacket(@mouseover="update('GreenPacket')")
					.brand-item.imocha(@mouseover="update('iMocha')")
					.brand-item.ipay88(@mouseover="update('iPay88')")
					.brand-item.kipplepay(@mouseover="update('kiplePay')")
					.brand-item.xox(@mouseover="update('XOX')")
</template>

<script>
export default {
	data() {
		return {
			index: 0,
			name: "",
			title: ""
		}
	},
	methods: {
		clickLeft() {
    if (this.index > 0)
      this.index -= 1
    else
      this.index = 2
    $(".carousel").animate({
      right: this.index * $(".item").outerWidth()
    }, 500)
  },
  clickRight() {
    if (this.index < 2)
      this.index += 1
    else
      this.index = 0
    $(".carousel").animate({
      right: this.index * $(".item").outerWidth()
    }, 500)
  },
  scroll(i) {
    this.index = i;
    $(".carousel").animate({
      right: this.index * $(".item").outerWidth()
    }, 500)
  },
  update(val) {
    this.name = val;
    this.title = val;
  }
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/overview.scss";
</style>